import { useRef, useEffect } from "react";
import styles from "../styles/Hero.module.css";      // note: .module.css
import HeroBackground from "../images/nadali_background.mp4";
import HeroLogo from "../images/nadali_logo.jpg";

export default function Hero() {

	const videoRef = useRef();

	useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1; // ← change this value

    }
  }, []); // runs once after mount

  return (
    <section className={styles.hero}>
      {/* Video as background */}
      <video
        className={styles.backgroundVideo}
        ref={videoRef}
        src={HeroBackground}
        autoPlay
        loop
        muted
        playsInline
      >
      </video>

      {/* Content on top */}
      <div className={styles.heroContent}>
        <div className={styles.heroLogo}>
        </div>
      </div>
    </section>
  );
}